import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=c1cfc0e2&scoped=true&lang=html&"
import script from "./transactions.vue?vue&type=script&lang=js&"
export * from "./transactions.vue?vue&type=script&lang=js&"
import style0 from "./transactions.vue?vue&type=style&index=0&id=c1cfc0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cfc0e2",
  null
  
)

export default component.exports